export default class WeatherAnimation extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.style.display = 'none';
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name === 'display') {
      this.style.display = 'none';
    }
  }

  setAnimation() {}

  removeAnimation() {}

  pauseAnimation() {}

  resumeAnimation() {}

  static get observedAttributes() {
    return ['style'];
  }
}
